import { BackgroundGradientAnimation } from "@/components/ui/background-gradient-animation";
import PlasmaWarpBackground from "./PlasmaWarpBackground";

export default function BackgroundGradient() {
  // Rollback hatch — ?bg=blob reverts to the old ambient-blob background.
  if (typeof window !== "undefined" && new URLSearchParams(window.location.search).get("bg") === "blob") {
    return (
      <div aria-hidden style={{ position: "fixed", inset: 0, zIndex: 0 }}>
        <BackgroundGradientAnimation
          gradientBackgroundStart="rgb(13, 9, 23)"
          gradientBackgroundEnd="rgb(20, 13, 34)"
          firstColor="113, 83, 158"
          secondColor="90, 60, 135"
          thirdColor="83, 60, 128"
          fourthColor="64, 41, 101"
          fifthColor="128, 105, 165"
          pointerColor="113, 83, 158"
          size="72%"
          blendingValue="hard-light"
          interactive={true}
          containerClassName="w-full h-full"
        />
      </div>
    );
  }

  return <PlasmaWarpBackground />;
}
